import React, { useEffect, useState } from 'react';
import { ArrowLeft, X, Check, Wallet } from 'lucide-react';
import './paymentConfirm.css';
import { CrossButton } from 'components';
import PinVerificationModal from 'modals/PinVerificationModal';
import OtpVerificationModal from 'modals/OtpVerificationModal';
import { getEasebuzzConfigurationApi, verifyConfigurationApi } from '_services';
import toast from 'react-hot-toast';


const PaymentConfirmModal = ({ isOpen, closeModal, isProcessing, setIsProcessing, setIsOpenPayNow, easebuzzDetails }) => {
    const [selectedMethod, setSelectedMethod] = useState('NEFT');
    const [isPinModalOpen, setIsPinModalOpen] = useState(false)
    const [isOtpModalOpen, setIsOtpModalOpen] = useState(false);
    const [easebuzzData, setEasebuzzData] = useState(false)
    const [transferMethods, setTransferMethods] = useState([]);

    const getEasebuzzConfiguration = async () => {
        const payload = {
            eb_account_id: easebuzzDetails?.eb_account_id
        }

        try {
            const res = await getEasebuzzConfigurationApi(payload)
            if (res?.responseCode === 200) {
                const config = res.data.configuration;
                setEasebuzzData(config)
                const methods = config.mode_of_payment.map(mode => ({
                    id: mode.id,
                    name: mode.mode,
                    time: mode.mode.includes('NEFT') ? '2-3 hours processing' : 'Instant transfer',
                    fee: mode.txn_charge,
                    maxTxnPerDay: mode.max_txn_per_day,
                    maxAmountPerDay: mode.max_amount_per_day,
                    minTxnAmount: mode.min_txn_amount,
                    maxTxnAmount: mode.max_txn_amount,
                    dailyFreeLimit: mode.daily_free_limit,
                    remainingFreeLimit: mode.daily_free_limit, // This should come from backend tracking,
                    value: mode.mode.includes('NEFT') ? 'NEFT' : 'IMPS',
                }));
                setTransferMethods(methods);
                setSelectedMethod(methods[0]?.value);
            }
        } catch (error) {

        }
    }

    // API call function when PIN is complete
    const handleVerifyPin = async (pin) => {
        // console.log(pin)
        let payload = {
            eb_account_id: easebuzzDetails?.eb_account_id,
            digit_pin: pin
        }

        try {
            const res = await verifyConfigurationApi(payload)
            if (res?.responseCode == 200) {
                if (easebuzzData?.threshold_limit == null) {
                    setIsPinModalOpen(false);
                    setIsProcessing({easebuzzData,easebuzzDetails,selectedMethod})
                } else {
                    setIsOtpModalOpen(true)
                    setIsPinModalOpen(false);
                }
                toast.success("Verify Successfull")
            } else {
                // toast.error(res?.responseMessage)
            }

        } catch (error) {

        }

    };

    // Handle forgot PIN
    const handleForgotPin = () => {
        // console.log('Forgot PIN clicked');
        setIsPinModalOpen(false);
    };


    const handleVerifyOtp = async (otp) => {
        // setIsProcessing(true)
         setIsProcessing({easebuzzData,easebuzzDetails,selectedMethod})
        setIsOtpModalOpen(false)
        setIsOpenPayNow(false)
    };

    const handleResendOtp = async () => {

    };

    useEffect(() => {
        getEasebuzzConfiguration()
    }, [])

    
    return (
        <div>
            <div
                className={`offcanvas offcanvas-end common_offCanvas ${isOpen ? "show" : ""}`}
                tabIndex={-1}
                style={{
                    visibility: isOpen ? "visible" : "hidden",
                }}
            >
                {isOpen && (
                    <>
                        <div className="offcanvas-header offcan_header">
                            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                <button
                                    style={{
                                        background: 'none',
                                        border: 'none',
                                        padding: '0',
                                        cursor: 'pointer',
                                        display: 'flex',
                                        alignItems: 'center'
                                    }}
                                    onClick={() => closeModal(false)}
                                >
                                    <ArrowLeft size={20} color="#000" />
                                </button>
                                <h5 className="offcanvas-title">Confirm Payment</h5>
                            </div>

                            <CrossButton type="button" className="_switchBtn  __animEffect_btn" style={{ marginLeft: 'auto' }} onClick={closeModal}>
                                <svg className="cross" xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none" >
                                    <path
                                        d="M12.5321 0.477671C12.4422 0.387555 12.3353 0.316061 12.2177 0.267281C12.1001 0.2185 11.9741 0.193391 11.8468 0.193391C11.7195 0.193391 11.5934 0.2185 11.4758 0.267281C11.3582 0.316061 11.2514 0.387555 11.1615 0.477671L6.40798 5.22143L1.6545 0.46795C1.56451 0.377952 1.45766 0.306563 1.34008 0.257857C1.22249 0.20915 1.09646 0.184082 0.969185 0.184082C0.84191 0.184082 0.715881 0.20915 0.598294 0.257857C0.480707 0.306563 0.373865 0.377952 0.283868 0.46795C0.19387 0.557947 0.122481 0.664789 0.0737746 0.782376C0.0250685 0.899963 -9.48274e-10 1.02599 0 1.15327C9.48275e-10 1.28054 0.0250684 1.40657 0.0737746 1.52416C0.122481 1.64175 0.19387 1.74859 0.283868 1.83858L5.03735 6.59206L0.283868 11.3455C0.19387 11.4355 0.122481 11.5424 0.0737746 11.66C0.0250685 11.7776 0 11.9036 0 12.0309C0 12.1581 0.0250685 12.2842 0.0737746 12.4017C0.122481 12.5193 0.19387 12.6262 0.283868 12.7162C0.373865 12.8062 0.480707 12.8776 0.598294 12.9263C0.715881 12.975 0.84191 13 0.969185 13C1.09646 13 1.22249 12.975 1.34008 12.9263C1.45766 12.8776 1.56451 12.8062 1.6545 12.7162L6.40798 7.9627L11.1615 12.7162C11.2515 12.8062 11.3583 12.8776 11.4759 12.9263C11.5935 12.975 11.7195 13 11.8468 13C11.974 13 12.1001 12.975 12.2177 12.9263C12.3353 12.8776 12.4421 12.8062 12.5321 12.7162C12.6221 12.6262 12.6935 12.5193 12.7422 12.4017C12.7909 12.2842 12.816 12.1581 12.816 12.0309C12.816 11.9036 12.7909 11.7776 12.7422 11.66C12.6935 11.5424 12.6221 11.4355 12.5321 11.3455L7.77861 6.59206L12.5321 1.83858C12.9015 1.46919 12.9015 0.847062 12.5321 0.477671Z"
                                        fill="black"
                                    />
                                </svg>
                            </CrossButton>
                        </div>

                        <div className="offcanvas-body">
                            <div className="__confPay_bxs">
                                {/* Payment Amount Section */}
                                <div className="__confPay_detailOtr">
                                    <div className="__conf_py_amount">
                                        <p>You're Paying</p>
                                        <h2>₹{easebuzzDetails?.total_amount || 0}</h2>
                                    </div>

                                    {easebuzzDetails?.vendor_bank_account?.ifsc_code && <div className="__conf_py_payDetails">
                                        <h4>To {easebuzzDetails?.vendor_bank_account?.account_name || ""}</h4>
                                        <p>
                                            {easebuzzDetails?.vendor_bank_account?.bank_name} - XXXX
                                            {easebuzzDetails?.vendor_bank_account?.account_number?.slice(-4)}
                                        </p>

                                        <p>IFSC Code - {easebuzzDetails?.vendor_bank_account?.ifsc_code}</p>
                                    </div>}
                                    {easebuzzDetails?.vendor_bank_account?.upi_id && <div className="__conf_py_payDetails">
                                        <h4>To {easebuzzDetails?.vendor_bank_account?.upi_id || ""}</h4>

                                    </div>}
                                </div>

                                {/* Transfer Method Section */}
                                <div className="__transfer_method_section">
                                    <div className="__transfer_header">
                                        <span className='methordTitle'>Select Transfer Method</span>
                                        <span className="__transaction_id">XXXX{easebuzzData?.easebuzz_account?.account_number.slice(-4) || ""}</span>
                                    </div>

                                    <div className="__transfer_options">
                                        {transferMethods.map((method) => (
                                            <div
                                                key={method.id}
                                                className={`__transfer_option ${selectedMethod === method.value ? '__selected' : ''}`}
                                                onClick={() => setSelectedMethod(method.value)}
                                            >
                                                <div className="__method_content">
                                                    <div className="__method_name">{method.name}</div>
                                                    <div className="__method_time">{method.time}</div>
                                                    <div className="__method_fee">₹{method.fee} Fee</div>
                                                </div>
                                                <div className="__method_radio">
                                                    <div className="__method_radio_inner">
                                                        {selectedMethod === method.value && (
                                                            <Check size={16} color="#10b981" strokeWidth={3} />
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>



                                </div>

                                {/* Wallet Balance Section */}
                                {selectedMethod == "NEFT" ? <div className="__wallet_info">
                                    <div className="__wallet_icon">
                                        <Wallet size={18} color="#3b82f6" />
                                    </div>
                                    <div className="__wallet_text">
                                        <p>
                                            <strong>₹{transferMethods.find(m => m.id === selectedMethod)?.fee}</strong> will be deducted from your wallet as convenience fee
                                        </p>
                                        <p className="__wallet_balance">Wallet Balance ₹ 5000</p>
                                    </div>
                                </div> :
                                    <div className="__wallet_info">
                                        <div className="__wallet_icon">
                                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <circle cx="10" cy="10" r="9" stroke="#0ea5e9" strokeWidth="2" />
                                                <path d="M10 6V11M10 14H10.01" stroke="#0ea5e9" strokeWidth="2" strokeLinecap="round" />
                                            </svg>
                                        </div>
                                        <div className="__wallet_text">
                                            <p className="__wallet_balance">Promotional Offer</p>
                                            <p>
                                                IMPS Convenience fee waived! Regular charge <strong>₹{5}</strong>. Daily limit 4 is pending
                                            </p>

                                        </div>
                                    </div>}
                            </div>
                        </div>

                        <div className="offcanvas-footer payConfirmCanvas">
                            <button className="anime-btn _addComm_btn" onClick={() => setIsPinModalOpen(true)}>
                                Proceed to Pay
                            </button>
                        </div>
                    </>
                )}
            </div>

            {isPinModalOpen && <PinVerificationModal
                isOpen={isPinModalOpen}
                onClose={() => setIsPinModalOpen(false)}
                onVerify={handleVerifyPin}
                onForgotPin={handleForgotPin}
            />}
            {isOtpModalOpen && <OtpVerificationModal
                isOpen={isOtpModalOpen}
                onClose={() => setIsOtpModalOpen(false)}
                onVerify={handleVerifyOtp}
                onResendOtp={handleResendOtp}
                phoneNumber="9977800300"
                otpValidityMinutes={10}
            />}
        </div>
    );
};

export default PaymentConfirmModal;